<div class="modal-body content width-600 ">
  <div class="layout-auto-1-auto">
    <span *ngIf="isUpload && !isOnlyDownload" class="modal-header">
      Bilddokumentation abschließen
    </span>
    <span *ngIf="!isUpload && !isOnlyDownload" class="modal-header">
      Bilddokumentation editieren
    </span>
    <span *ngIf="isOnlyDownload">
      Bilddokumentation downloaden
    </span>
    <div class="content layout-auto-1">
      <div></div>
      <div class="content">
        <form #pdForm="ngForm">
          <exg-input  [(ngModel)]="pdName"
                      [caption]="'Dateiname'"
                      [maxlength]="256"
                      name="pdName"
                      [required]="true"
                      [minlength]=1
                      #pdNameInput="ngModel">
          </exg-input>
          <exg-textarea [(ngModel)]="pdDescription"
                        [caption]="'Beschreibung'"
                        [maxlength]="2048"
                        *ngIf="!isOnlyDownload"
                        name="pdDescription">
          </exg-textarea>
          <!--<div class="grid cols-2">
            <app-exg-select-v2 name="DokTypeSelect"
                               caption="{{enumSvc.getFieldCaption('Dokument','dok_enmIdent_DokTyp')}}"
                               [(ngModel)]="dokTypeIndex"
                               [list]="enumSvc.getEnumerationList('DokTyp')"
                               listDisplay="enmText">
            </app-exg-select-v2>
            <p class="grid cols-2" *ngIf="userType === 1">
              <label>Freigabe Trackingportal:</label>
              <input type="checkbox" [checked]="dokTrackingPortalShare"
                     (change)="dokTrackingPortalShare= !dokTrackingPortalShare">
            </p>
          </div>-->
          <app-exg-select-v2 [(ngModel)]="stateIndex"
                             [list]="enumSvc.getEnumerationList('PhotoDocumentationStatus')"
                             *ngIf="!isOnlyDownload"
                             listDisplay="enmText"
                             caption="Status"
                             name="status">
          </app-exg-select-v2>
        </form>
      </div>
    </div>
    <div class="spawn-modal-actions typo-small">
      <ng-container *ngIf="isOnlyDownload">
        <button (click)="save()"
                class="md-btn"
                [disabled]="pdForm.invalid || !pdName.trim().length">
          Download
        </button>
        <button (click)="cancel()" class="md-btn">
          Abbrechen
        </button>
      </ng-container>
      <ng-container *ngIf="!isOnlyDownload">
        <button *ngIf="!isUpload && data?.editModel?.pdID"
                (click)="delete()"
                class="md-btn">
          {{getGlobal('Delete')}}
        </button>
        <button (click)="cancel()" class="md-btn">
          Abbrechen
        </button>
        <button *ngIf="!isUpload"
                (click)="save('saveAs')"
                class="md-btn"
                [disabled]="pdForm.invalid || !pdName.trim().length">
          Speichern unter
        </button>
        <button (click)="save('save')"
                class="md-btn"
                [disabled]="pdForm.invalid || !pdName.trim().length">
          Speichern
        </button>
      </ng-container>
    </div>
  </div>
</div>
